<template>
  <step-section
    :title="$t('filesStepTitle')"
    :description="$t('filesStepDescription')"
  >
  <div class="row row--custom">

    <div
      class="col-12 col-xl-12"
      v-if="files.length < 5"
      :class="{'col-6-width': files.length < 5}"
    >
      <div class="error-notice" v-if="errors && errors.length > 0">
        <ul>
          <li v-for="(error, index) in errors" :key="index">
            {{ error }}
          </li>
        </ul>
      </div>

      <div
        class="drop-content"
        @drop="handleDrop"
        @dragover="handleDragOver"
        @dragleave="handleDragLeave"
      >
        <div class="drop-item">
          <form class="upload-form">
            <fieldset>
              <input
                type="hidden"
                id="MAX_FILE_SIZE"
                name="MAX_FILE_SIZE"
                value="1000000"
              >
              <div>
                <img
                  src="../../assets/images/upload.png"
                  class="img-fluid drop-drag"
                >
                <input
                  type="file"
                  id="fileselect"
                  name="fileselect[]"
                  multiple="multiple"
                  class="btn-main"
                  @change="handleInputChange"
                >
                <span class="text_file">
                  {{ $t('dragAndDrop') }}
                  <br>
                  {{ $t('or') }}</span>
                <label for="fileselect" class="btn-main">
                  {{ $t('selectFiles') }}
                </label>
                <legend>{{ $t('fileUploadLimits') }}</legend>
                <div id="submitbutton">
                  <button type="submit"></button>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
    <div
      class="col-12 col-xl-12"
      :class="{'col-6-width': files.length < 5}"
    >
      <div class="files-content">
        <table class="table-files">
          <thead>
            <tr>
              <th></th>
              <th>{{ $t('fileName') }}</th>
              <th>{{ $t('format') }}</th>
              <th>{{ $t('size') }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody id="messages">
            <tr v-if="files.length === 0">
              <td colspan="6">
                {{ $t('filesEmpty') }}
              </td>
            </tr>
            <template v-else>
              <tr
                v-for="file in files"
                :key="file.id"
              >
                <td>
                  <div
                    class="checkbox checkbox--white"
                    v-if="!file.uploading"
                    @click="toggleFileSelect(file)"
                  >
                    <input
                      class="checkbox__input"
                      type="checkbox"
                      :checked="isFileSelected(file)"
                    >
                    <label for="checkbox1" class="checkbox__label"></label>
                  </div>
                </td>
                <td>
                  {{ file.name }}
                  <progress
                    v-if="file.uploading"
                    :max="100"
                    :value="file.progress"
                  />
                </td>
                <td>{{ file.format }}</td>
                <td>{{ formatSize(file.size) }}</td>
                <td>
                  <button
                    type="button"
                    class="delete-btn"
                    v-if="!file.uploading"
                    @click="() => handleRemoveFile(file)"
                  >
                    <span class="icon icon-delete"></span>
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <button
        class="btn-remove"
        type="button"
        v-if="selectedFiles && selectedFiles.length > 0"
        @click="removeSelectedFiles"
      >
        <span class="icon icon-delete"></span>
        {{ $t('removeSelected') }}
      </button>
    </div>
  </div>
  </step-section>
</template>

<script>
  import filesize from 'filesize';
  import { MAX_FILES, MAX_FILE_SIZE } from '@/constants';
  import { mapActions, mapState, mapMutations } from 'vuex';
  import stepMixin from './stepMixin';

  export default {
    name: 'FilesStep',
    mixins: [stepMixin],
    data() {
      return {
        selectedFiles: [],
        errors: [],
      };
    },
    methods: {
      ...mapActions({
        addFile: 'configurator/addFile',
      }),
      ...mapMutations({
        removeFile: 'configurator/removeFile',
      }),
      handleRemoveFile(file) {
        if (file.uploading) {
          return;
        }

        this.removeFile(file.id);
      },
      handleDragOver(ev) {
        ev.preventDefault();
      },
      handleDragLeave(ev) {
        ev.preventDefault();
      },
      handleDrop(ev) {
        ev.preventDefault();
        const { files } = ev.dataTransfer;
        this.handleFiles(files);
      },
      handleInputChange(ev) {
        const files = ev.target.files || ev.dataTransfer.files;
        this.handleFiles(files);
      },
      handleFiles(files) {
        const { $t } = this;

        if (!files.length === 0 || files.length > MAX_FILES) {
          this.errors = [
            $t('youHaveSelectedTooManyFiles', {
              limit: MAX_FILES,
              filesText: $t('files', { count: files.length }),
            }),
          ];
          return;
        }

        this.errors = [];

        Array.from(files).forEach(file => {
          if (file.size > MAX_FILE_SIZE) {
            this.errors.push(
              $t('addedFileExceedMaxFileSize', { fileName: file.name }),
            );
            return;
          }

          this.addFile(file);
        });
      },
      formatSize(size) {
        return filesize(size);
      },
      removeSelectedFiles() {
        const { selectedFiles } = this;

        selectedFiles.forEach(fileId => this.removeFile(fileId));
      },
      toggleFileSelect(file) {
        const { selectedFiles } = this;

        if (selectedFiles.includes(file.id)) {
          selectedFiles.splice(selectedFiles.indexOf(file.id), 1);
        } else {
          selectedFiles.push(file.id);
        }
      },
      isFileSelected(file) {
        return this.selectedFiles.includes(file.id);
      },
    },
    computed: {
      ...mapState({
        files: state => state.configurator.files,
      }),
      maxFileSizeText() {
        return filesize(MAX_FILE_SIZE);
      },
    },
  };
</script>
